"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Geolocation = void 0;
const pro_regular_svg_icons_1 = require("@fortawesome/pro-regular-svg-icons");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const DisplayGeolocation = styled_components_1.default.a `
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: ${({ customStyle }) => { var _a, _b; return (_b = (_a = customStyle === null || customStyle === void 0 ? void 0 : customStyle.content) === null || _a === void 0 ? void 0 : _a.justify) !== null && _b !== void 0 ? _b : 'center'; }};
	color: ${({ theme, customStyle }) => { var _a, _b; return (_b = (_a = customStyle === null || customStyle === void 0 ? void 0 : customStyle.color) === null || _a === void 0 ? void 0 : _a.hyperlink) !== null && _b !== void 0 ? _b : theme.denimBlue; }};
	svg {
		margin-right: 5px;
	}

	&:focus {
		border: 1px solid $black;
	}

	@media only screen and (max-width: $xxs-size) {
		display: flex;
		flex-direction: column;
	}
	text-decoration: none;
`;
const Geolocation = ({ applyGeolocation, useMyLocation, customStyle }) => {
    return (react_1.default.createElement(DisplayGeolocation, { href: '#', onClick: applyGeolocation, customStyle: customStyle },
        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_regular_svg_icons_1.faLocationArrow }),
        useMyLocation));
};
exports.Geolocation = Geolocation;
